import { render, staticRenderFns } from "./DialogTipTaxaServico.vue?vue&type=template&id=47ea466e&lang=pug"
import script from "./DialogTipTaxaServico.vue?vue&type=script&lang=js"
export * from "./DialogTipTaxaServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports